import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import API_URL from '../config';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const [verPassword, setVerPassword] = useState(false);

  useEffect(() => {
    localStorage.removeItem('user');
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const res = await fetch(`${API_URL}/api/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });

      const data = await res.json();

      if (data.success) {
        localStorage.setItem('user', JSON.stringify(data.user));
        navigate('/insumos');
      } else {
        setError(data.message);
      }
    } catch (err) {
      console.error(err);
      setError('Error de conexión');
    }
  };

  return (
    <div
      className="login-background"
      style={{
        backgroundImage: "url('/fondoLogin.jpg')",
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <div className="login-box">
        <h1 className="title">Inventario</h1>
        <p className="subtitle">Laboratorios Vida-Salud</p>
        <form onSubmit={handleLogin}>
          <div style={{ position: 'relative', marginBottom: '1rem' }}>
            <input
              type="text"
              placeholder="Usuario"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '0.5rem 0.5rem',
                fontSize: '1rem',
                borderRadius: '10px',
                border: '1px solid #ccc',
                fontFamily: "'Poppins', sans-serif",
                backgroundColor: '#fff',
                color: '#333'
              }}
            />
          </div>

          <div style={{ position: 'relative', marginBottom: '1rem' }}>
            <input
              type={verPassword ? 'text' : 'password'}
              placeholder="Contraseña"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '0.5rem 2.5rem 0.5rem 0.5rem',
                fontSize: '1rem',
                borderRadius: '10px',
                border: '1px solid #ccc',
                fontFamily: "'Poppins', sans-serif"
              }}
            />
            <div
              onClick={() => setVerPassword(!verPassword)}
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                color: '#666',
                fontSize: '1.2rem'
              }}
            >
              {verPassword ? <FaEyeSlash /> : <FaEye />}
            </div>
          </div>

          {error && <p style={{ color: 'red', fontSize: '14px' }}>{error}</p>}
          <button type="submit">Iniciar Sesión</button>
        </form>
      </div>
    </div>
  );
};

export default Login;